// extracted by mini-css-extract-plugin
export var buttons = "_3d-0";
export var buttonsActive = "_3d-h";
export var cancelConfirm = "_3d-1";
export var closeButton = "_3d-2";
export var column = "_3d-3";
export var container = "_3d-4";
export var detailHeader = "_3d-6";
export var detailTitle = "_3d-7";
export var detailsContent = "_3d-5";
export var header = "_3d-8";
export var headerWithClose = "_3d-9";
export var icon = "_3d-a";
export var infoIcon = "_3d-c";
export var informationContainer = "_3d-b";
export var sideDrawer = "_3d-d";
export var sideDrawerOpen = "_3d-e";
export var stickyFooter = "_3d-f";
export var typeOption = "_3d-g";